import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--background-main)' }}>
      <div className="text-center">
        <h1 className="text-9xl font-bold opacity-20" style={{ color: 'var(--text-primary)' }}>
          404
        </h1>
        <h2 className="text-2xl font-bold mt-4" style={{ color: 'var(--text-primary)' }}>
          ページが見つかりません
        </h2>
        <p className="mt-2" style={{ color: 'var(--text-secondary)' }}>
          お探しのページは存在しないか、移動した可能性があります。
        </p>
        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={() => window.history.back()}
            className="btn-secondary flex items-center gap-2"
          >
            <ArrowLeft size={18} />
            戻る
          </button>
          <Link to="/" className="btn-primary flex items-center gap-2">
            <Home size={18} />
            ホームへ
          </Link>
        </div>
      </div>
    </div>
  );
}

